import Utils, {NUMBER_FORMAT_SEPARATOR_TYPE} from "./Utils";


export default class InputUtils {
    static readonly EMAIL_REGEX = new RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    static readonly PASSWORD_REGEX = new RegExp(/^[^\s](.+){2,}[^\s]$/); //matches more or equal to 4 symbols
    static readonly USERNAME_REGEX = new RegExp(/^([a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*){4,}$/); //matches more or equal to 4 symbols and only letters

    // Maps used for storing previously used number format RegExp for given locale
    private static readonly LOCALE_NUMBER_DECIMAL_REGEX_CACHE = new Map<string, RegExp>();
    private static readonly LOCALE_NUMBER_INT_REGEX_CACHE = new Map<string, RegExp>();

    private static getDefaultValue(value: any) {
        const type = typeof value;
        switch(type) {
            case "string":
                return '';
            case "boolean":
                return false;
            case "number":
                return 0;
            case "object":
                return Array.isArray(value) ? [] : {} ;
        }
    }

    /**
     * Summary:
     * This method resets the valid and value prop of a field in a form object.
     * Each field in the form object must contain value and valid prop
     */
    static resetForm(form: any) {
        const keys = Object.keys(form);
        let formCopy = JSON.parse(JSON.stringify(form));
        keys.forEach(key => {
            formCopy = {
                ...formCopy,
                [key]: {
                    ...formCopy[key],
                    value: InputUtils.getDefaultValue(formCopy[key].value),
                    valid: true
                }
            }
        })
        return formCopy;
    }

    static getDecimalNumberValidationRegex = (localeTag: string) => {
        if (InputUtils.LOCALE_NUMBER_DECIMAL_REGEX_CACHE.has(localeTag)) {
            return InputUtils.LOCALE_NUMBER_DECIMAL_REGEX_CACHE.get(localeTag);
        }
        const regex = InputUtils.generateDecimalNumberFormatRegex(localeTag);
        return InputUtils.LOCALE_NUMBER_DECIMAL_REGEX_CACHE.set(localeTag, regex).get(localeTag);
    };

    static getIntNumberValidationRegex = (localeTag: string) => {
        if (InputUtils.LOCALE_NUMBER_INT_REGEX_CACHE.has(localeTag)) {
            return InputUtils.LOCALE_NUMBER_INT_REGEX_CACHE.get(localeTag);
        }
        const regex = InputUtils.generateIntNumberFormatRegex(localeTag);
        return InputUtils.LOCALE_NUMBER_INT_REGEX_CACHE.set(localeTag, regex).get(localeTag);
    };

    private static generateDecimalNumberFormatRegex = (localeTag: string) => {
        const thousandSeparator = Utils.getFormattedNumberSeparator(localeTag, NUMBER_FORMAT_SEPARATOR_TYPE.GROUP);
        const decimalSeparator = Utils.getFormattedNumberSeparator(localeTag, NUMBER_FORMAT_SEPARATOR_TYPE.DECIMAL);
        const regex = '^[\\d\\' + thousandSeparator + ']+(\\' + decimalSeparator + '\\d*)?$'
        return new RegExp(regex);
    };

    private static generateIntNumberFormatRegex = (localeTag: string) => {
        const thousandSeparator = Utils.getFormattedNumberSeparator(localeTag, NUMBER_FORMAT_SEPARATOR_TYPE.GROUP);
        const regex = '^[\\d\\' + thousandSeparator + ']+$';
        return new RegExp(regex);
    };
}

export enum Type {
    INPUT ,
    SELECT,
    CREATABLE_SELECT,
    DATE,
    TEXT_AREA,
    INPUT_SWITCH,
    JSON_CONTAINER,
    NUMBER,
    ASYNC_PAGINATE
};



// WEBPACK FOOTER //
// ./app/InputUtils.ts